module.exports = __webpack_public_path__ + "static/media/avatar.a8b60016.svg";